import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { NgWaitComponent } from "./ng-wait.component";
import { NgProgressSpinner } from "../ng-progressspinner/ng-progressspinner";
import { NgWaitService } from "./ng-wait.service";

function NgWaitServiceFactory(): NgWaitService {
    return NgWaitService.getInstance();
}

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        NgWaitComponent,
        NgProgressSpinner
    ],
    providers: [
        {
            provide: NgWaitService,
            useFactory: NgWaitServiceFactory
        }
    ],
    exports: [
        NgWaitComponent,
        NgProgressSpinner
    ]
})
export class NgWaitModule { }
